/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PenaltyDuration } from './PenaltyDuration';
import {
    PenaltyDurationFromJSON,
    PenaltyDurationFromJSONTyped,
    PenaltyDurationToJSON,
} from './PenaltyDuration';

/**
 * 
 * @export
 * @interface PenaltyTier
 */
export interface PenaltyTier {
    /**
     * 
     * @type {PenaltyDuration}
     * @memberof PenaltyTier
     */
    probationDuration: PenaltyDuration | null;
    /**
     * 
     * @type {PenaltyDuration}
     * @memberof PenaltyTier
     */
    lockoutDuration: PenaltyDuration | null;
}

/**
 * Check if a given object implements the PenaltyTier interface.
 */
export function instanceOfPenaltyTier(value: object): value is PenaltyTier {
    if (!('probationDuration' in value) || value['probationDuration'] === undefined) return false;
    if (!('lockoutDuration' in value) || value['lockoutDuration'] === undefined) return false;
    return true;
}

export function PenaltyTierFromJSON(json: any): PenaltyTier {
    return PenaltyTierFromJSONTyped(json, false);
}

export function PenaltyTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PenaltyTier {
    if (json == null) {
        return json;
    }
    return {
        
        'probationDuration': PenaltyDurationFromJSON(json['probationDuration']),
        'lockoutDuration': PenaltyDurationFromJSON(json['lockoutDuration']),
    };
}

export function PenaltyTierToJSON(value?: PenaltyTier | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'probationDuration': PenaltyDurationToJSON(value['probationDuration']),
        'lockoutDuration': PenaltyDurationToJSON(value['lockoutDuration']),
    };
}

